import React, { FC } from 'react'
import { Form as ReactstrapForm } from 'reactstrap'

export const Form: FC = ({ children }) => <ReactstrapForm>{children}</ReactstrapForm>
